module.exports = __webpack_public_path__ + "static/media/caia.8912e016.png";